export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10955.3125f0a7.jpg";